// @ts-strict-ignore
import * as React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { antGrey } from '../styles/globalStyles';
import { StepItemLinkContainer, StepItemText, StepItemTextContainer } from './StepItem';
import Icon, { SignalFilled } from '@ant-design/icons';
import { useSidebarColors } from '../styles/themeMode';

interface AdditionalItemProps {
    itemText: string;
    route: string;
    icon: typeof SignalFilled;
    leftNode?: React.ReactNode;
    isLastNode?: boolean;
}
const AdditionalItem = ({ itemText, route, icon, leftNode, isLastNode = false }: AdditionalItemProps) => {
    const sc = useSidebarColors();
    const [isHovered, setIsHovered] = React.useState(false);
    const match = useRouteMatch(route);
    const isActive = !!match;
    return (
        <li
            style={{ borderBottom: isLastNode ? `0.5px solid ${sc.border}` : 'none' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Link to={route}>
                <StepItemLinkContainer isActive={isActive} isHovered={isHovered}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', minWidth: 0 }}>
                        {leftNode}
                        <StepItemTextContainer>
                            <StepItemText>{itemText}</StepItemText>
                        </StepItemTextContainer>
                        <Icon
                            component={icon}
                            style={{ color: antGrey.grey7, paddingTop: '12px', paddingBottom: '12px', marginLeft: 8 }}
                        />
                    </div>
                </StepItemLinkContainer>
            </Link>
        </li>
    );
};

export default AdditionalItem;
